module.exports = __webpack_public_path__ + "img/popup_icon_like_pressed.db67f4d7.svg";